import imgAdora1 from "./img-adora (1).webp";
import imgAdora2 from "./img-adora (2).webp";

const imgAdora = [imgAdora1, imgAdora2];

export default imgAdora;
